// eslint-disable-next-line import/prefer-default-export
export enum DepositLastStatusEnum {
  Forwarding = 'Forwarding',
  Countersending = 'Counter Sending',
  Fueling = 'Fueling',
  Complete = 'Complete',
  ForwardingFailed = 'Forwarding Failed',
  FuelingFailed = 'Fueling Failed',
  CountersendingFailed = 'Counter Sending Failed',
  ReplayDeposit = 'Replay Deposit',
}
